import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";
import { formatRelative } from 'date-fns'
import Vue from "vue";

export default {
  name: "resources",
  components: {
    Multiselect,
  },
  props: [],
  data() {
    return {
      view: {
        loadingResources: false,
      },
      filter: {
        tags: null,
        string: null,
        group: null,
      },
    };
  },
  computed: {
    storeResources() {
      return this.$store.getters.docFiles(this.filter, "resources");
    },
    resources() {
      return this.$store.state.resources;
    },
    user() {
      return this.$store.getters.userData;
    },
    org() {
      return this.$store.getters.activeOrg;
    },
    resourcesTags() {
      return this.$store.getters.resourcesTags;
    },
    groups() {
      return this.$store.state.groups.docs;
    },
    groupListNames() {
      // for populating the group filter
      let list = [];
      for (const res in this.groups) {
        let obj = {
          name: this.groups[res]["name"],
          id: this.groups[res]["id"],
        };
        list.push(obj);
      }
      return list;
    },
  },
  watch: {
    groupListNames () {
      // check for a groups filter
      if (this.$route.query.group) {
        // check if we have the group info, if not we need to loop for it
        if (this.groupListNames.length) {
          let data = this.groupListNames.find(
            (obj) => obj.id === this.$route.query.group
          );
          this.filter.group = data;
        } else {
          console.log("NO DOCS YET");
        }
      }
    }
  },
  mounted() {
    console.log("resources mounted:", this.storeResources);
    if (this.$route.query.tags) {
      this.filter.tags = this.$route.query.tags.split(",") || null;
    }
  },
  methods: {
    groupFilterInput() {
      // update query params, filter results appropriately
      const query = Object.assign({}, this.$route.query);

      // query.group = this.filter.group.join(",")
      console.log("group filter changed, now:", this.filter.group);

      if (this.filter.group) {
        query.group = this.filter.group.id;
      } else {
        delete query.group;
      }

      this.$router.push({ query });
    },
    tagSearchInput() {
      console.log("tag search changed, now:", this.filter.tags);
      // filter resourceDirectory for resources that contain the tags in the input

      // update tags in query param
      const query = Object.assign({}, this.$route.query);

      query.tags = this.filter.tags.join(",");

      if (!this.filter.tags.length) {
        delete query.tags;
        this.filter.tags = null;
      }

      console.log("query:", query);

      this.$router.push({ query });
    },
    async visibilityChanged(isVisible, entry, resource, index) {
      if (isVisible && !resource.loadedData) {
        console.log("we need to hydrate:", resource);
        let storeResource = this.$store.getters.resource(resource.id);

        if (!storeResource || !storeResource.loadedData) {
          storeResource = await this.$store.dispatch("fetchDocData", {
            id: resource.id,
            collection: "resources",
          });
        }

        this.$set(resource, storeResource);
      }
    },
    // formattedDate(resource) {
    //   if (!resource.updatedDateFormatted) return null;

    //   // let twoCode = (navigator.language || navigator.userLanguage).split("-")[1]
    //   // let options = {
    //   //   locale: {
    //   //     code: twoCode,
    //   //     localize: (thing) => thing
    //   //   }
    //   // }

    //   let returnText = formatRelative(
    //     resource.updatedDateFormatted,
    //     new Date()
    //   );

    //   return returnText;
    // },
  },
};